import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';

import {SearchData} from '../../../services/common-datatypes';
import {AutoUnsubscribe} from '../../../decorators/common.decorators';
import {Subscription} from 'rxjs';
import {StateStorageService} from '../../../services/state-storage.service';
import {RestDataService} from '../../../services/rest-data.service';
import {FileSaverService} from 'ngx-filesaver';
import {CommonFunctionsService} from '../../../services/common-functions.service';
//import {pickModes} from 'ion2-calendar/dist/config';
import {NavController} from '@ionic/angular';
import * as dayjs from 'dayjs';

const EXPORT_WARNING = 3000;

@Component({
    selector: 'app-search-form',
    templateUrl: './search-form.component.html',
    styleUrls: ['./search-form.component.scss']
})
export class SearchFormComponent implements OnInit, OnDestroy {

    public searchData: SearchData;
    public searchType: string = '';
    public userDepartment: string = '';
    public splitPaneVisible: boolean = false;
    public exportBusy = false;
    public showExport = false;
    public showExportWarning = false;
    public exportError = '';

    @Input() inSettings = false;

    // noinspection JSMismatchedCollectionQueryUpdate
    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    public dateOptions: any;
    // CalendarModalOptions = {
    //     pickMode: pickModes.RANGE,
    //     title: 'buy date range', // will be replaced in constructor
    //     canBackwardsSelected: true,
    //     defaultDate: new Date(),
    // };

    constructor(private navController: NavController,
                private appState: StateStorageService,
                private dataService: RestDataService,
                private commonFunctions: CommonFunctionsService,
                private fileSaverService: FileSaverService) {
        _('search.free_simple.all');
        _('search.free_simple.name');
        _('search.free.all');
        _('search.free.name');
        _('search.free.exact');
        _('search.location.all');
        _('search.location.name');
        _('search.location.exact');
        _('search.date.all');
        _('search.date.name');
        _('search.date.input');
        _('search.category.all');
        _('search.category.name');
        this.searchData = new SearchData(this.appState.defaultSearchSort);
    }

    ngOnInit(): void {
        this.splitPaneVisible = this.appState.splitPaneVisible;
        this.setSearchData(this.appState.searchData);
        this.userDepartment = this.appState.authData.department ?? '';
        this.showExport = false;

        if (this.inSettings) {
            this.setSearchData(this.appState.settings.defaultSearch);
            return;
        }

        this.showExport = this.commonFunctions.hasAuthRole('EXPORT', this.appState.authData.role);

        this.subscriptions.push(
            this.appState.searchData$
                .subscribe((data: SearchData) => {
                    this.setSearchData(data);
                })
        );
        this.subscriptions.push(
            this.appState.splitPaneVisible$
                .subscribe((visible: boolean) => {
                    this.splitPaneVisible = visible;
                })
        );
    }

    public ngOnDestroy(): void {
    }

    private setSearchData(data: SearchData) {
        if (!data) return;

        this.showExportWarning = (data.countResults > EXPORT_WARNING); // count update ist not treated as search update
        this.exportError = '';
        if (this.searchData && this.searchData.isSame(data)) return;

        // NOTE: we copy the data from the given search data object to our own search data
        // this search data object will not be copied any more but passed to all children of this form as reference
        //       so each change will be reflected in this object
        const updateData = new SearchData(this.appState.defaultSearchSort);
        updateData.updateFromJson(data);
        if (updateData.simple) this.searchType = 'simple';
        else this.searchType = 'complex';
        this.searchData = updateData;
    }

    public updateSimple() {
        this.searchData.simple = (this.searchType === 'simple');
        this.reportSearchData();
    }

    public resetSearchData() {
        const simple = this.searchData.simple;
        this.searchData.updateFromJson(this.appState.settings.defaultSearch);
        this.searchData.simple = simple;
        this.reportSearchData();
    }

    public clearSearchData() {
        const simple = this.searchData.simple;
        this.searchData.reset();
        this.searchData.simple = simple;
        this.reportSearchData();
    }

    public reportSearchData() {
        // publish search and call search page with id of new published search
        this.appState.searchData = this.searchData;
        if (!this.inSettings) this.navController.navigateRoot('/search', {queryParams: {sid: this.appState.searchData.id}});
    }

    public exportData() {
        this.exportBusy = true;
        this.dataService.getExport(this.searchData).then(
            (data: Blob) => {
                this.fileSaverService.save((<any>data), 'inventur_export' + dayjs().format('_YYYY_MM_DD_HH_mm_ss') + '.xlsx');
                this.exportBusy = false;
            },
            (err: any) => {
                if (err) this.exportError = err.message;
                this.exportBusy = false;
            });
    }
}
